import { render, staticRenderFns } from "./MindoTabs.vue?vue&type=template&id=68fcccad&"
import script from "./MindoTabs.vue?vue&type=script&lang=js&"
export * from "./MindoTabs.vue?vue&type=script&lang=js&"
import style0 from "./MindoTabs.vue?vue&type=style&index=0&id=68fcccad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports